// @flow
import type { SimProductPriceActionType } from './actions';

export const initialState: SimProductType = {
  price: 0,
};

export default (state: SimProductType = initialState, action: SimProductPriceActionType) => {
  switch (action.type) {
    case 'FETCH_SIM_PRODUCT_PRICE_SUCCESS':
      return {
        price: action.payload.price,
      };

    default:
      return state;
  }
};

export type SimProductType = {|
  price: number,
|};
